import EditIcon from "@usas/ui-web/components/icons/EditIcon";
import DeleteIcon from "@usas/ui-web/components/icons/DeleteIcon";
import SGColumnHeader from "@usas/ui-web/components/grids/SGColumnHeader";

import useSortableGrid from "@usas/ui-web/utils/UseSortableGrid";
import SGConstants from "@usas/ui-web/utils/SGConstants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeGridRow = ({ member, onEditClicked, onEditStatusClicked, onDeleteClicked }) => (
  <tr>
    <td>{member.firstName || ''} {member.lastName || ''}</td>
    <td>{member.zoneOrgUnitName || ''}</td>
    <td>{member.competitionGenderTypeName || ''}</td>
    {onEditStatusClicked && member.canEditStatus === true
      ? <td><a onClick={(e) => onEditStatusClicked(e, member)}>{member.personOrgGroupQualificationStatus}</a></td>
      : <td>{member.personOrgGroupQualificationStatus || ''}</td>
    }
    <td>
      {onEditClicked &&
        <button
          className={global.IconButtonMargin}
          type="button"
          onClick={(e) => onEditClicked(e, member)}>
          <EditIcon />
        </button>
      }
      {onDeleteClicked &&
        <button
          className={global.IconButtonMargin}
          type="button"
          onClick={(e) => onDeleteClicked(e, member)}>
          <DeleteIcon />
        </button>
      }
    </td>
  </tr>
);

const SAAGroupMembersGridLarge = ({ data, isLoading, onEditClicked, onEditStatusClicked, onDeleteClicked }) => {
  const {
    sortableGridState,
    onColumnClicked
  } = useSortableGrid(data);

  return (
    <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
      <thead>
        <tr>
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Name'} columnField={'lastName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Zone'} columnField={'zoneOrgUnitCode'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Competition Category'} columnField={'competitionGenderTypeCode'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Status'} columnField={'personOrgGroupQualificationStatus'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {isLoading === true
          ? <tr><td colSpan="5">Loading...</td></tr>
          : sortableGridState.sortedGridData.length > 0
            ? sortableGridState.sortedGridData.map((member, i) => <LargeGridRow key={i} member={member} onEditClicked={onEditClicked} onEditStatusClicked={onEditStatusClicked} onDeleteClicked={onDeleteClicked} />)
            : <tr><td colSpan="5">No Group Members</td></tr>
        }
      </tbody>
    </table>
  );
};

export default SAAGroupMembersGridLarge;